import { render, staticRenderFns } from "./spellActiveModal.vue?vue&type=template&id=6fb0556b&scoped=true"
import script from "./spellActiveModal.vue?vue&type=script&lang=js"
export * from "./spellActiveModal.vue?vue&type=script&lang=js"
import style0 from "./spellActiveModal.vue?vue&type=style&index=0&id=6fb0556b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb0556b",
  null
  
)

export default component.exports